// Library methods
import { useTranslation } from "react-i18next";

// Components
import { Button, Grid, Typography } from "@mui/material";
import DefaultModal from "../../DefaultModal";

// Styles
import {
  ModalCustomCancel,
  ModalCustomConfirm,
} from "../../../../styles/muiStylesHelper";

const LiveUpdateNavigationModal = ({ isOpen, onClose, onConfirm }) => {
  // translations
  const { t } = useTranslation();

  return (
    <DefaultModal
      isOpen={isOpen}
      onClose={onClose}
      title={t("button_view_report")}
      maxWidth="xs"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Button variant="text" sx={ModalCustomCancel} onClick={onClose}>
            {t("button_close")}
          </Button>
          <Button
            variant="outlined"
            sx={ModalCustomConfirm}
            onClick={onConfirm}
          >
            {t("word_view")}
          </Button>
        </Grid>
      }
    >
      <Grid p="20px">
        <Typography>{t("navigate_report_description")}</Typography>
      </Grid>
    </DefaultModal>
  );
};

export default LiveUpdateNavigationModal;
